import { FaApple, FaAndroid, FaGlobe, IconType } from '../lib/icons';

const PLATFORM_DISPLAY: Record<string, { label: string; IconC: IconType; tint: string }> = {
  apple_ios:      { label: 'App Store',    IconC: FaApple,   tint: 'bg-gray-100 text-gray-800' },
  stripe_ios:     { label: 'Stripe · iOS', IconC: FaApple,   tint: 'bg-purple-50 text-purple-700' },
  stripe_android: { label: 'Play Store',   IconC: FaAndroid, tint: 'bg-green-50 text-green-700' },
  stripe_web:     { label: 'Web · Stripe', IconC: FaGlobe,   tint: 'bg-blue-50 text-blue-700' },
};

export function PlatformBadge({ value }: { value: string | null | undefined }) {
  if (!value) return <span className="text-gray-300 text-xs">—</span>;
  const meta = PLATFORM_DISPLAY[value];
  if (!meta) {
    const pretty = value.split('_').map((s) => s[0]?.toUpperCase() + s.slice(1)).join(' ');
    return <span className="text-xs font-semibold inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-gray-100 text-gray-700">{pretty}</span>;
  }
  const Icon = meta.IconC;
  return (
    <span className={`text-xs font-semibold inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full ${meta.tint}`}>
      <Icon /> {meta.label}
    </span>
  );
}

const STATUS_DISPLAY: Record<string, { label: string; tint: string }> = {
  active:    { label: 'Active',     tint: 'bg-green-50 text-green-700' },
  past_due:  { label: 'Past due',   tint: 'bg-amber-50 text-amber-800' },
  canceled:  { label: 'Canceled',   tint: 'bg-gray-100 text-gray-700' },
  expired:   { label: 'Expired',    tint: 'bg-red-50 text-red-700' },
  trialing:  { label: 'Trialing',   tint: 'bg-blue-50 text-blue-700' },
  paused:    { label: 'Paused',     tint: 'bg-gray-100 text-gray-700' },
};

export function StatusPill({ status }: { status: string | null | undefined }) {
  if (!status) return <span className="text-[11px] text-gray-300">—</span>;
  const meta = STATUS_DISPLAY[status];
  const label = meta?.label || status.replace(/_/g, ' ');
  const tint = meta?.tint || 'bg-gray-100 text-gray-500';
  return <span className={`text-[11px] font-semibold px-2 py-0.5 rounded-full capitalize ${tint}`}>{label}</span>;
}
